import { IdPosition, IdAlgo, SectionType, SectionItemType } from '@bc/shared';
import AnalyticsEvent from './analytics-event';

class ViewTile extends AnalyticsEvent {
  public readonly name = 'view_tile';

  constructor(
    public readonly properties: {
      page_number?: number;
      value_proposition?: string;
      value_proposition_id?: number;
      id_section?: string;
      id_algo?: IdAlgo;
      id_product?: IdPosition[];
      id_brand?: IdPosition[];
      position?: number | number[];
      itemtype?: SectionItemType;
      section_type?: SectionType;
      section_position?: number;
    }
  ) {
    super();
  }
}

export default ViewTile;
